import React from 'react';

const Header = () => {
    return (
        <div className="header">
            <h1>Expense Tracker</h1>
        </div>
    );
};

export default Header;
